import { render, staticRenderFns } from "./addbenefitAccount.vue?vue&type=template&id=e80d0180&scoped=true&"
import script from "./addbenefitAccount.vue?vue&type=script&lang=js&"
export * from "./addbenefitAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80d0180",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e80d0180')) {
      api.createRecord('e80d0180', component.options)
    } else {
      api.reload('e80d0180', component.options)
    }
    module.hot.accept("./addbenefitAccount.vue?vue&type=template&id=e80d0180&scoped=true&", function () {
      api.rerender('e80d0180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/benefitAccount/components/addbenefitAccount.vue"
export default component.exports